import axios from "axios";
import env from "variables/config";
import { errorHandler } from "./utils";

axios.defaults.baseURL = env.apiUrl;

const config = () => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    };
};

export interface CompanyAddress {
    streetNumber?: string;
    streetType?: string;
    streetName?: string;
    postalCode?: string;
    city?: string;
    country?: string;
}

export interface FounderInfo {
    nom?: string;
    prenom?: string;
    nomUsage?: string;
    dateNaissance?: string;
    lieuNaissance?: string;
    nationalite?: string;
    qualite?: string; // CEO, Président, Directeur Général, etc.
    dateDebutMandat?: string;
    dateFinMandat?: string;
    adresse?: {
        ligne1?: string;
        ligne2?: string;
        codePostal?: string;
        ville?: string;
        pays?: string;
    };
    // Legacy fields for backward compatibility
    firstName?: string;
    lastName?: string;
    fullName?: string;
    role?: string;
    birthDate?: string;
    birthPlace?: string;
    type?: 'physical' | 'moral';
    isFounder?: boolean;
}

export interface BodaccRecord {
    id: string;
    publicationDate: string;
    announcementType: string;
    announcementFamily: string;
    tribunal: string;
    company: {
        denomination: string;
        commercialName?: string;
        legalForm: string;
        registrationNumber: string;
        registrationCourt?: string;
        personType?: string;
        capital?: {
            amount: string;
            currency: string;
        };
        address: CompanyAddress;
    };
    founders: FounderInfo[];
    partners: Array<{
        name?: string;
        role?: string;
        type?: 'physical' | 'moral';
        details?: any;
    }>;
    establishments: Array<{
        type: string;
        activity: string;
        address: CompanyAddress;
    }>;
    legalActs: {
        creationDate?: string;
        registrationDate?: string;
        activityStartDate?: string;
        creationCategory?: string;
    };
    administration?: {
        raw: string;
        parsed: Array<{
            role: string;
            person: string;
            location?: string;
        }>;
    };
    rawData: any;
}

export interface CompanySearchResponse {
    data: BodaccRecord[];
    siren?: string;
    siret?: string;
    searchTerm?: string;
    meta: {
        recordCount: number;
        searchedAt: string;
        searchType?: "siren" | "siret" | "name";
    };
}

/**
 * Search by SIREN (9 digits) or SIRET (14 digits).
 */
export const searchCompanyByIdentifier = async (identifier: string): Promise<{ data: CompanySearchResponse | null; error: any }> => {
    try {
        const clean = identifier.replace(/\s/g, "");
        const res = await axios.get(`/scanner/search/${clean}`, config());
        return { data: res.data, error: null };
    } catch (error: any) {
        const errorResponse = errorHandler(error);
        return { data: null, error: errorResponse.error };
    }
};

/** @deprecated Use searchCompanyByIdentifier — accepts both SIREN and SIRET */
export const searchCompanyBySiren = searchCompanyByIdentifier;

export const searchCompanyByName = async (companyName: string, limit: number = 20): Promise<{ data: CompanySearchResponse | null; error: any }> => {
    try {
        const res = await axios.get(`/scanner/search-by-name/${encodeURIComponent(companyName)}?limit=${limit}`, config());
        return { data: res.data, error: null };
    } catch (error: any) {
        const errorResponse = errorHandler(error);
        return { data: null, error: errorResponse.error };
    }
};